import { VideoResult } from "common/video/dto/VideoResult";
import { PageNavigation } from "components/common/SearchResultList";
import PlayVideoItem from "./PlayVideoItem";
import { useSakusasVideoSearch } from "hooks/sakusas/video/useSakusasVideoSearch";
import { VIDEO_PER_PAGE_MAX } from "constant/video";
import { useEffect, useState } from "react";
import { VideoSearchParams } from "common/api/sakusas/sakusas_video";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";
import { QUERY_KEYS } from "constant/react_query";
import styled from "styled-components";
import { SEARCH_NAMES } from "constant/search";

const PER_PAGE_MAX = 12;

const VideoList = () => {
  const [searchParams, setSearchParams] = useState<VideoSearchParams>({
    [SEARCH_NAMES.LIMIT]: PER_PAGE_MAX,
    [SEARCH_NAMES.SKIP]: 0,
  });
  const videoListResult = useSakusasVideoSearch(searchParams);
  const invalidateQuery = useInvalidateQueryByKeys();
  useEffect(() => {
    invalidateQuery.invalidateQueriesByKeys([QUERY_KEYS.SAKUSAS_VIDEO_SEARCH]);
  }, [searchParams]);

  let results: VideoResult[] = videoListResult ? videoListResult["items"] : [];

  setTimeout(() => {
    invalidateQuery.invalidateQueriesByKeys([QUERY_KEYS.SAKUSAS_VIDEO_SEARCH]);
  }, 5 * 1000);

  return (
    <Div>
      {results.map((video: VideoResult) => (
        <PlayVideoItem video={video} key={`video${video.id}`} />
      ))}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  margin-top: 2rem;
  margin-left: 0%;
  width: 100%;
  flex-wrap: wrap;
`;

export default VideoList;
